import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.religion;

const getReligion = createSelector(getData, religion => values(religion));

export default getReligion;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getReligion.js